module.exports = __webpack_public_path__ + "img/1.22_Russian_road_sign.8c5eb8e1.svg";